import { render } from "./ProsesKK.vue?vue&type=template&id=d7851264"
import script from "./ProsesKK.vue?vue&type=script&lang=js"
export * from "./ProsesKK.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__